import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { EditLinkButton } from "Components/Shared/Buttons/EditLinkButton";
import { ResponsiveDialog } from "Components/Shared/Dialogs/ResponsiveDialog";
import { PublicInfoCard } from "Components/Social/PublicInfoCard";
import { HandleForm } from "Components/UserAccount/Shared/PublicInformation/HandleForm";
import { Resources, useResource } from "Translations/Resources";
import { useState } from "react";

/**
 * "@handle" card of the public-information tab (the landing spot of the dashboard
 * HandleMissingBanner) with its own edit dialog. The handle stays editable; changing
 * it releases the old one immediately.
 */
export const HandleCard = () => {
  const { t } = useResource();
  // React Query user-info, not the Redux user — the legacy sign-in flows stamp Redux
  // from SignInResult, which carries no handle, so it reads empty until a full reload.
  const { data: userInfo } = useUserInfoQuery();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handle = userInfo?.handle;

  return (
    <>
      <PublicInfoCard
        label={t(Resources.Social.Handle.Label)}
        value={handle ? `@${handle}` : null}
        action={<EditLinkButton onClick={() => setIsDialogOpen(true)} />}
      />
      <ResponsiveDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        title={t(Resources.Social.Handle.Label)}
      >
        <HandleForm onSuccess={() => setIsDialogOpen(false)} />
      </ResponsiveDialog>
    </>
  );
};
